export default __webpack_public_path__ + "static/media/2.cd311749.svg";